module.exports = __webpack_public_path__ + "img/dwdwedwddwe.4bd4ee52.png";